import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Injectable()
export class PlanningConfirmTransportService {
  private base_url = `${environment.API_URL}/planning`;
  private token = localStorage.getItem("token");
  private headers = new HttpHeaders().set("Authorization", `${this.token}`);
  constructor(private http: HttpClient) {}

  sendPlanningConfirmTransport(body: object) {
    return this.http.post(`${this.base_url}/confirm_transport`, body, { headers: this.headers });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_services/planning-confirm-transport.service.ts